const CircleToolIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  const size = "24px";

  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="4.25" stroke={finalColor} strokeWidth="1" />
    </svg>
  );
};

export default CircleToolIcon;
